import React, { Component } from "react";
import { connect } from "react-redux";
import * as _ from "lodash";
import { withTranslation, Trans } from "react-i18next";
import SearchBar from "material-ui-search-bar";
import { withRouter, Redirect } from "react-router-dom";
import { auth } from "../../service/firebase";
import Services from "../../api/api";
import ChatMenuList from "./ChatMenuList";
import { removeSpacetoLowerCase } from "../../api/helper";
import { signup, signin, signInAnonymously } from "../../helpers/auth";

import imgUrl from "../../assets/images/imageUrl.js";

import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HomeIcon from "@material-ui/icons/Home";
import List from "@material-ui/core/List";

import InnerHeader from "../Layout/InnerHeader";
import Loader from "../loaders/loader";
import DialogBox from "../DialogBox/DialogBox";
import DialogBoxUseAuth from "../DialogBox/DialogBoxUseAuth";
import { setFirebaseUserDetail } from "../../redux/actions/appActions";
import swal from "sweetalert";
import { gaLogEvent } from "../../helpers/analytics";

//import "../../assets/css/customstyles.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "36ch",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
}));

class ChatList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      orignalList: [],
      applicantObj: {},
      isLoading: true,
      open: false,
    };
    this.openChat = this.openChat.bind(this);
    this.handleOnSearch = this.handleOnSearch.bind(this);
    this.cancelSearch = this.cancelSearch.bind(this);
  }

  componentDidMount() {
    try{
      gaLogEvent("chat "+this.props.compChatType, '', '');
    }catch(err){
      console.log("err::", err);
    }

    this.setState({ isLoading: true });
    console.log(this.props.compChatType)
    if (this.props.compChatType == "peer") {
      let userId = JSON.parse(localStorage.getItem("obj")).userId;
      let params = {
        communityId: this.props.communityuid,
        userId: userId,
        roleType: [
          "GuestUser",
          "Applicant"
        ],
      };
      console.log("params:::", params)
      this.getApplicantList(params)
      this.getFirebaseUserList();
    } else if (this.props.compChatType == "admin") {
      let params = {
        communityId: this.props.communityuid,
        roleType: ["Admin"]
      };

      this.getApplicantList(params)
      this.getFirebaseUserList();
    } else {
      // this.setState({
      //   list: this.props.chatConfig.chatGroup,
      //   isLoading: false,
      // });
      this.getChatForumList();
    }
  }

  getApplicantList(params) {
    Services.getApplicantList(params).then((res) => {
      try {
        if (res.data.status == 200) {
          let filterList = [];
          res.data.data.map((applicant) => {
            if(applicant.isactive && applicant.userName == 'isave@mailinator.com'){
              filterList.push(applicant);
            }
          });
          this.setState({
            list: filterList,
            orignalList: filterList,
            isLoading: false,
          });
        }
      } catch (err) {
        console.log("Error::", err);
      }
    });
  }


  getChatForumList() {
    let params = {
      communityId: this.props.communityuid,
      isactive: true,
    };
    console.log(params)

    Services.getForumChatGroupByCommunityId(params).then((res) => {
      try {
        console.log(res)
        if (res && res.data.status == 200) {
          let tempList = res.data.data.map(ele => {
            return { ...ele, title: ele.groupName }
          })
          this.setState({
            list: tempList
          });
        }
        this.getChatForumListMsgCount();
      } catch (err) {
        console.log("err::", err)
      }
    }).catch((err) => {
      this.setState({
        list: [],
        isLoading: false,
      });
    });;
  }

  getChatForumListMsgCount() {
    let params = {
      communityId: this.props.communityuid,
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };
    console.log("getChatForumListMsgCount", params)

    Services.getForumGroupMsgCountForUserByCommunityId(params).then((res) => {
      try {
        console.log("message count", res.data.data);
        console.log("this.state.list", this.state.list);
        var myTempList = this.state.list;
        for (var i = 0; i < myTempList.length; i++) {
          console.log("ele::", myTempList[i]);
          for (var j = 0; j < res.data.data.length; j++) {
            console.log("myele", j);
            if (myTempList[i].id == res.data.data[j].groupId) {
              myTempList[i].countOfMsgs = res.data.data[j].countOfMsgs;
            }
          }
        }
        console.log("object3", myTempList)
        this.setState({
          list: myTempList,
          orignalList: myTempList,
          isLoading: false
        })
      } catch (err) {
        console.log("err::", err)
      }
    }).catch((err) => {
      this.setState({
        list: [],
        isLoading: false,
      });
    });;
  }

  gotoChat(user) {
    ///layout/peerchat/chatwindow
    console.log("gotoChat>>", user, this.state.applicantObj);
    if (user != null) {
      this.props.history.push({
        pathname: "/layout/chatwindow",
        state: {
          applicant: this.state.applicantObj,
          userObj: user,
          chatType: this.props.compChatType,
        },
      });
    } else {
      // this.signInAnonymously()
      var loggedinnameonly = (JSON.parse(localStorage.getItem("obj")).userId).toString();
      var loggedinname = (JSON.parse(localStorage.getItem("obj")).userId).toString();
      if(loggedinname){
        // create a valid email for firebase login if user is using id
        if(loggedinname.indexOf('@') == -1){
          loggedinname = loggedinname + '@myrights.com';
          if(loggedinname.indexOf(' ') != -1){
            loggedinname = loggedinname.split(' ').join('_');
          }
        }
        signup(loggedinname, "P@ssw0rd")
          .then((userCredential) => {
            console.log("userCredential", userCredential)
            // Signed in 
            var user = userCredential.user;
            // user.updateProfile({
            //   displayName: loggedinnameonly,
            // })
            // ...
            this.gotoChat(user);
          })
          .catch((error) => {
            console.log("error", error)
            signin(loggedinname, "P@ssw0rd")
              .then((userCredential) => {
                console.log("userCredential", userCredential)
                // Signed in 
                var user = userCredential.user;
                // user.updateProfile({
                //   displayName: loggedinnameonly,
                // })
                // ...
                this.gotoChat(user);
              })
              .catch((error) => {
                console.log("error", error)
                var errorCode = error.code;
                var errorMessage = error.message;
                // ..
              });
          });
      }
    }
  }

  getFirebaseUserList() {
  }

  buttonClick() {
    this.props.changeTab();
  }

  closeDialog() {
    this.setState({ open: false });
  }

  closeDialogAuth() {
    this.setState({ openAuth: false });
  }

  openChat(applicantObj) {
    var usertabflag = false;
    var menuList = JSON.parse(localStorage.getItem("menuList"));
    var tab = menuList.filter(obj => obj.path == 'peerchat');
    if (tab.length > 0) {
      var usretab = tab[0].childs.filter(obj => obj.isactive && obj.visible && obj.path == "user");
      if (usretab.length > 0) {
        usertabflag = true;
      }
    }
    this.setState({ applicantObj, }, () => {
      if (auth().currentUser == null && usertabflag) {
        this.setState({ open: true });
      } else {
        if (JSON.parse(localStorage.getItem("obj")).roleType == "GuestUser") {
          if (applicantObj.isModeratorRequired) {
            this.checkIfForumchatIsApproved(applicantObj)
          } else {
            this.setState({ isLoading: true });
            this.gotoChat(auth().currentUser);
          }

        } 
        // else {
        //   this.setState({ isLoading: true });
        //   this.gotoChat(auth().currentUser);
        // }
      }
    }
    );
  }

  checkIfForumchatIsApproved(applicantObj) {
    let params = {
      communityId: this.props.communityuid,
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      forumId: applicantObj.id,
      forumLabel: applicantObj.label
    };
    Services.checkIfForumchatIsApproved(params).then((res) => {
      try {
        let forumChatApproval = res.data.data.forumChatApproval;
        if (forumChatApproval == true) {
          this.setState({ isLoading: true });
          this.gotoChat(auth().currentUser);
        } else {
          this.setState({ openAuth: true });
        }
      } catch (err) {
        console.log("Error::", err);
      }
    });
  }

  async createUser(email, password = "P@ssw0rd") {
    try {
      await signup(email, password).then((res) => {

        this.signinWithEmail(email, password);
      });
    } catch (error) {
      if (error.code == "auth/email-already-in-use") {
        this.signinWithEmail(email, password);
      }
    }
  }

  async signInAnonymously() {
    try {
      await signInAnonymously()
        .then((res) => {
          auth().onAuthStateChanged((user) => {

            if (user && JSON.parse(localStorage.getItem("obj")).roleType == "GuestUser") {
              this.gotoChat(user);
            } else {
              console.log("error>>", user);
            }
          });
        })
        .catch();
    } catch (error) {
      this.setState({ error: error.message });
    }
  }

  async signinWithEmail(email, password) {
    try {
      await signin(email, password)
        .then((res) => {
          auth().onAuthStateChanged((user) => {
            if (user && JSON.parse(localStorage.getItem("obj")).roleType == "GuestUser") {
              this.gotoChat();
            } else {
              console.log("error>>", user);
            }
          });
        })
        .catch();
    } catch (error) {
      this.setState({ error: error.message });
    }
  }


  handleOnSearch = (e) => {

    let topicList = _.cloneDeep(this.state.orignalList);
    let filtered = [];
    filtered = topicList.filter(function (str) {
      return ((str.id + '').indexOf(e) !== -1 || (str.nickName + '').indexOf(e) !== -1);
    });
    if (e.length == 0) {
      filtered = _.cloneDeep(this.state.orignalList);
    }
    this.setState({
      list: filtered,
    });
  };

  cancelSearch(e) {
    this.setState({
      list: this.state.orignalList,
    });
  }


  render() {
    const { t } = this.props;
    const { classes, theme } = this.props;
    if (this.props.compChatType == "") {
      return null;
    }

    // console.log(this.state.list,auth().currentUser)
    // if(this.state.list.length == 1 && auth().currentUser != null) {
    //    return <Redirect to={{
    //     pathname: "/layout/chatwindow",
    //     state: {
    //       applicant: this.state.list[0],
    //       userObj: auth().currentUser,
    //       chatType: this.props.compChatType,
    //     },
    //   }} 
    //   />;
    // } else if (this.state.list.length == 1 && auth().currentUser == null){
    //   this.gotoChat(auth().currentUser)
    // }


    return (
      <div
        className={
          this.props.compChatType == "peer" ? "peer-list" : "group-list"
        }
      >
        {this.state.isLoading ? (
          <Loader isLoading={this.state.isLoading} />
        ) : (
          <>
            {this.props.compChatType == "peer" ? (
              <SearchBar
                placeholder={t('Search')}
                className="getaccess-searchbar mb-10px"
                onChange={this.handleOnSearch}
                onCancelSearch={this.cancelSearch}
                style={{ borderColor: this.props.componentbgcolor }}
              />) : ('')
            }
            {this.state.list &&
              this.state.list.map((rowObj) => {
                return (
                  <ChatMenuList
                    key={rowObj.id}
                    chatType={this.props.compChatType}
                    rowObj={rowObj}
                    openChat={(rowObj) => this.openChat(rowObj)}
                  />
                );
              })
            }
            {this.state.list.length == 0 ? (<div>{t('Data not found')}</div>) : ('')}
          </>
        )}
        <DialogBox
          open={this.state.open}
          closeDialog={() => this.closeDialog(false)}
          buttonClick={() => this.buttonClick()}
        />

        <DialogBoxUseAuth
          open={this.state.openAuth}
          closeDialog={() => this.closeDialogAuth(false)}
          buttonClick={() => this.closeDialogAuth(false)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
    userobj: storeState.userDetail,
    chatConfig: storeState.chatConfig,
    fbuserObj: storeState.fbuserObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transChatList = withTranslation()(ChatList);
const ThemeChatList = withTheme(transChatList);
const FinalThemeChatList = withStyles(useStyles)(ThemeChatList);
const routeChatList = withRouter(FinalThemeChatList);
export default connect(mapStateToProps, { setFirebaseUserDetail })(
  routeChatList
);
